import { useEffect } from 'react';
import { ref, getDatabase, child, onChildChanged, off } from 'firebase/database';

import getConfig from 'next/config';
import { getApps, initializeApp } from 'firebase/app';

const { FIREBASE_ENV = false, NODE_ENV = 'development' } = getConfig().publicRuntimeConfig;

export const initFirebase = () => {
  if (getApps().length === 0) {
    initializeApp({
      apiKey: 'AIzaSyBwWGgfubbQVLpP5jnc1tglAdcoUXDz0MU',
      authDomain: 'boatsetter-messaging.firebaseapp.com',
      databaseURL: 'https://boatsetter-messaging.firebaseio.com',
      projectId: 'boatsetter-messaging',
      storageBucket: 'boatsetter-messaging.appspot.com',
      messagingSenderId: '611815132408',
      appId: '1:611815132408:web:65fc7de4dc9c84a2dc7f0d',
    });
  }
};

const Firebase = (props) => {
  const { handleChange, conversationId, userId } = props;

  useEffect(() => {
    const firebasePath = `${FIREBASE_ENV || NODE_ENV}/conversationsByUser`;
    const convoRef = ref(getDatabase(), firebasePath);
    const convoChild = child(convoRef, userId);

    const listener = (snapshot) => {
      const { key } = snapshot;
      handleChange(key);
    };

    onChildChanged(convoChild, listener);

    return () => off(convoChild);
  }, [conversationId, handleChange, userId]);

  return <div style={{ display: 'none' }} />;
};

export default Firebase;
